import {
    faCircleXmark,
    faFloppyDisk,
    faMoon as farMoon,
    faStar as farStar,
} from "@fortawesome/free-regular-svg-icons";
import {
    faCcVisa,
    faCcMastercard,
    faCcAmex,
    faCcDinersClub,
    faTwitter,
    faFacebook,
    faInstagram,
    faYoutube,
    faCcPaypal,
    faCcApplePay,
    faGooglePay,
} from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faSort,
    faCircleQuestion,
    faCarBurst,
    faPersonWalkingArrowRight,
    faAddressCard,
    faCloudArrowDown,
    faUserSecret,
    faIndustry,
    faSadTear,
    faUpDownLeftRight,
    faCog,
    faLocationCrosshairs,
    faTachometerAlt,
    faEdit,
    faTrash,
    faPlus,
    faUserPlus,
    faUserCircle,
    faSave,
    faBook,
    faBed,
    faCheck,
    faPowerOff,
    faBomb,
    faCircleExclamation,
    faCircleInfo,
    faTriangleExclamation,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faCircleChevronRight,
    faCalendarDay,
    faTimes,
    faSpinner,
    faTrashRestore,
    faCreditCard,
    faLock,
    faSignal,
    faBatteryFull,
    faBatteryHalf,
    faBatteryQuarter,
    faBatteryThreeQuarters,
    faBatteryEmpty,
    faLockOpen,
    faBell,
    faDoorOpen,
    faSkullCrossbones,
    faClockRotateLeft,
    faListUl,
    faUser,
    faHome,
    faBars,
    faCloudDownloadAlt,
    faCompass,
    faSearchLocation,
    faRulerHorizontal,
    faMoon,
    faCheckCircle,
    faSignInAlt,
    faSignOutAlt,
    faRotateRight,
    faKey,
    faTruck,
    faHammer,
    faUserTie,
    faSuitcase,
    faUmbrellaBeach,
    faQuestion,
    faBroom,
    faPassport,
    faCashRegister,
    faFileInvoice,
    faLink,
    faHotel,
    faMoneyBillAlt,
    faUsers,
    faArrowLeft,
    faUndoAlt,
    faAngleLeft,
    faAngleRight,
    faAnglesLeft,
    faAnglesRight,
    faFilter,
    faPaperPlane,
    faUserGroup,
    faChartPie,
    faDownload,
    faClipboard,
    faClipboardCheck,
    faArchway,
    faHandHoldingDollar,
    faMap,
    faMapMarkerAlt,
    faStar,
    faStarHalf,
    faStarHalfStroke,
    faBan,
    faDiagramProject,
    faBuilding,
    faBuildingColumns,
    faEnvelope,
    faPhone,
    faFilePdf,
    faVideo,
    faWeight,
    faXmark,
    faGear,
    faPen,
    faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
// import {
// } from "@fortawesome/free-"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";
library.add(
    faUserSecret,
    faIndustry,
    faCog,
    faTachometerAlt,
    faEdit,
    faTrash,
    faPlus,
    faUserPlus,
    faUserCircle,
    faSave,
    faBook,
    faBed,
    faCheck,
    faPowerOff,
    faBomb,
    faCircleExclamation,
    faTriangleExclamation,
    faCircleXmark,
    faChevronDown,
    faChevronUp,
    faCircleChevronRight,
    faCalendarDay,
    faTimes,
    faSpinner,
    faTrashRestore,
    faCreditCard,
    faLock,
    faSignal,
    faBatteryFull,
    faBatteryHalf,
    faBatteryQuarter,
    faBatteryThreeQuarters,
    faBatteryEmpty,
    faLockOpen,
    faBell,
    faDoorOpen,
    faSkullCrossbones,
    faClockRotateLeft,
    faListUl,
    faUser,
    faHome,
    faBars,
    faCloudDownloadAlt,
    faCompass,
    faSearchLocation,
    faMagnifyingGlass,
    faRulerHorizontal,
    faMoon,
    faCheckCircle,
    farMoon,
    faSignInAlt,
    faSignOutAlt,
    faRotateRight,
    faKey,
    faTruck,
    faHammer,
    faUserTie,
    faSuitcase,
    faUmbrellaBeach,
    faQuestion,
    faBroom,
    faPassport,
    faCcVisa,
    faCcMastercard,
    faCcAmex,
    faCcDinersClub,
    faCashRegister,
    faFileInvoice,
    faLink,
    faHotel,
    faMoneyBillAlt,
    faUsers,
    faArrowLeft,
    faUndoAlt,
    faAngleLeft,
    faAngleRight,
    faAnglesLeft,
    faAnglesRight,
    faFilter,
    faPaperPlane,
    faUserGroup,
    faChartPie,
    faDownload,
    faClipboard,
    faClipboardCheck,
    faArchway,
    faHandHoldingDollar,
    faChevronLeft,
    faChevronRight,
    faMap,
    faMapMarkerAlt,

    faTwitter,
    faFacebook,
    faInstagram,
    faYoutube,
    faStar,
    faCcPaypal,
    faCcApplePay,
    faGooglePay,
    faBan,
    faDiagramProject,
    faBuilding,
    faBuildingColumns,
    faEnvelope,
    faPhone,
    faFilePdf,
    faVideo,
    faWeight,
    faCircleInfo,
    faSadTear,
    faStarHalfStroke,
    faStarHalf,
    farStar,
    faLocationCrosshairs,
    faCloudArrowDown,
    faXmark,
    faFloppyDisk,
    faGear,
    faCarBurst,
    faPen,
    faUpDownLeftRight,
    faCircleQuestion,
    faPersonWalkingArrowRight,
    faSort,
    faAddressCard
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
